import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { HeroLine, Reveal } from "./Reveal";
import { Overline } from "./Section";

export const PageHero = ({ overline, title, subtitle, image, crumb }) => (
  <section className="relative pt-[74px] overflow-hidden bg-dash-ink" data-testid="page-hero">
    <div className="absolute inset-0">
      <motion.img
        src={image}
        alt=""
        className="h-full w-full object-cover"
        initial={{ scale: 1.15 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-dash-ink via-dash-ink/90 to-dash-ink/40" />
      <div className="grain" />
    </div>

    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 py-24 md:py-36">
      <Reveal>
        <nav className="flex items-center gap-1.5 text-sm text-white/50 mb-8" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-white">Home</Link>
          <ChevronRight className="h-3.5 w-3.5" />
          <span className="text-dash-teal">{crumb}</span>
        </nav>
      </Reveal>
      <div className="mb-5"><Overline light>{overline}</Overline></div>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl font-bold text-white leading-[1.02] max-w-4xl">
        {title.split("\n").map((line, i) => (
          <HeroLine key={i} delay={0.15 + i * 0.12}>{line}</HeroLine>
        ))}
      </h1>
      <Reveal delay={0.4}>
        <p className="mt-7 text-lg md:text-xl text-white/75 max-w-2xl leading-relaxed">{subtitle}</p>
      </Reveal>
    </div>
  </section>
);
